import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers/stack'
import { Input } from 'primitives/input'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { WidgetHeaderBar } from '../../../components/live_chat_widget/widget_header_bar'
import { ApiErrorMessage } from '../../../controls/errors/api_error_message'
import { useAxios } from '../../../hooks/use_axios'
import { useRefCallback } from '../../../hooks/use_ref_callback'
import { updateLiveChatAccount } from '../../../reduxes/slices/accounts/actions'
import { makeGetContact } from '../../../reduxes/slices/contacts/selectors'
import { getCurrentHandle } from '../../../reduxes/slices/current/selectors'
import {
  getCurrentAnswers,
  getCurrentQuestion,
} from '../../../reduxes/slices/questions/selectors'
import { handleApiError } from '../../../reduxes/util/parse_server_error'
import liteApiRoutes from '../../../routes/lite_api_routes.json'
import { AppLocationContext } from '../../admin/app_location_provider'
import { WidgetContext } from '../widget_page_router'
import { questionContainerStyles, spacerStyles } from './styles'

export const EmailCapture = () => {
  const currentQuestion = useSelector(getCurrentQuestion)
  const { setAppLocation } = useContext(AppLocationContext)
  const answers = useSelector(getCurrentAnswers)
  const dispatch = useDispatch()
  const axios = useAxios()
  const [inputElement, inputElementCallback] =
    useRefCallback<HTMLTextAreaElement>()
  const [termsAccepted, setTermsAccepted] = useState(true)
  const currentHandle = useSelector(getCurrentHandle)
  const getContact = useMemo(makeGetContact, [])
  const contact = useSelector((state) =>
    getContact(state, { handle: currentHandle }),
  )
  const [emailInputValue, setEmailInputValue] = useState(contact?.email)
  const { handleAnswerAction } = useContext(WidgetContext)

  useEffect(() => {
    setEmailInputValue(contact?.email)
  }, [contact])

  const submit = (event: any) => {
    event.preventDefault()
    if (termsAccepted) {
      const formData = new FormData(event.target)
      const name = formData.get('name')
      const email = formData.get('email')
      const marketingConsent = formData.get('marketingConsent')
      if (!email || !email.includes('@')) {
        handleApiError({
          dispatch,
          result: {
            config: { method: 'put' },
            response: { data: { error: 'Invalid email' } },
          },
          path: liteApiRoutes.lite_api_v1_account.path,
        })
        return
      }
      // name, notify
      dispatch(
        axios(
          updateLiveChatAccount({
            email,
            marketing_consent: marketingConsent === 'on',
          }),
        ),
      ).then(() => {
        handleAnswerAction(answers[0])
        // if (notify === false || notify === true) {
        //   setNotifyState(notify)
        // }
      })
    } else {
      setAppLocation({ widgetQuestionId: answers[0].action })
    }
  }

  return (
    <>
      <WidgetHeaderBar />
      <div className={spacerStyles()} />
      <Stack
        as={'form'}
        onSubmit={submit}
        gap={2}
        className={questionContainerStyles()}
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          zIndex: 1,

          h2: {
            textAlign: 'center',
          },
        }}
      >
        <h2>{currentQuestion.text}</h2>
        <div ref={inputElementCallback}>
          <Input
            name={'email'}
            value={emailInputValue}
            onChange={(e) => setEmailInputValue(e.target.value)}
            placeholder={'Email'}
          />
        </div>
        <Button variant={'primary'} className={btnStyles()} type={'submit'}>
          Continue
        </Button>
        {currentQuestion?.data?.marketing_consent_text &&
          <Stack gap={2} direction={'row'} css={{justifyContent: 'center'}}>
            <input
              type={'checkbox'}
              name={'marketingConsent'}
              checked={termsAccepted}
              onChange={() => setTermsAccepted((prevState) => !prevState)}
            />
            <label>
              {currentQuestion?.data?.marketing_consent_text}
            </label>
          </Stack>
        }
        <ApiErrorMessage
          httpMethod={'put'}
          route={liteApiRoutes.lite_api_v1_account.path}
          element={inputElement}
        />
      </Stack>
    </>
  )
}

const btnStyles = css({
  height: 42,
})
